import { Seo } from "@/components/site/Seo";
import { NoticeBar } from "@/components/site/NoticeBar";
import { Hero } from "@/components/home/Hero";
import { Stats } from "@/components/home/Stats";
import { Expertise } from "@/components/home/Expertise";
import { Teasers } from "@/components/home/Teasers";
import { JsonLd } from "@/components/site/JsonLd";
import { homeSchema } from "@/data/structuredData";
import { useLang } from "@/i18n";

export default function Home() {
  const { lang } = useLang();
  return (
    <>
      <Seo page="home" />
      <JsonLd data={homeSchema(lang)} />
      <NoticeBar />
      <Hero />
      <Expertise />
      <Stats />
      <Teasers />
    </>
  );
}
